// extracted by mini-css-extract-plugin
module.exports = {"title":"radio_title__ZPrd6","titleOnRibbon":"radio_titleOnRibbon__DJfOZ","footerContainer":"radio_footerContainer__Tvi1H","ribbon":"radio_ribbon__OVBhI"};